// pagecomponents/Portfolio.jsx
import React, { useState, useEffect } from 'react';
import './Portfolio.css';

// Composant pour une carte projet - PAS D'OVERLAY !
const ProjectCard = ({ project, index }) => {
  return (
    <div 
      className="project-card"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="project-image-wrapper">
        <img src={project.image} alt={project.title} />
        <div className="project-tech-tags">
          {project.techs.map((tech, idx) => (
            <span key={idx} className="tech-tag">{tech}</span>
          ))}
        </div>
      </div>
      
      {/* Les infos sont TOUJOURS visibles - pas d'overlay */}
      <div className="project-info">
        <span className="project-category">{project.category}</span>
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        
        <div className="project-links">
          <a 
            href={project.liveUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="project-link live"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M15 3H21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Voir
          </a>
          <a 
            href={project.githubUrl || "https://github.com/eliletishbit"} 
            target="_blank" 
            rel="noopener noreferrer"
            className="project-link github"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 19C4 20.5 4 16.5 2 16M15 22V18.5C15.1 17.5 14.9 16.5 14.5 15.5C17.2 15.2 20 13.8 20 9.5C20 8.3 19.5 7.2 18.7 6.3C19.1 5.2 19.1 3.8 18.5 2.5C18.5 2.5 17.2 2.1 15 3.5C13.8 3.1 12.5 3.1 11.2 3.5C9 2.1 7.7 2.5 7.7 2.5C7.1 3.8 7.1 5.2 7.5 6.3C6.7 7.2 6.2 8.3 6.2 9.5C6.2 13.8 9 15.2 11.7 15.5C11.3 16.5 11.1 17.5 11.2 18.5V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

// Composant pour un projet en vedette
const FeaturedProject = ({ project }) => {
  if (!project) return null;
  
  return (
    <div className="featured-project">
      <div className="featured-image">
        <img src={project.image} alt={project.title} />
        <div className="featured-badge">Projet vedette</div>
      </div>
      <div className="featured-content">
        <span className="project-category">{project.category}</span>
        <h3 className="featured-title">{project.title}</h3>
        <p className="featured-description">{project.fullDescription || project.description}</p>
        <div className="featured-techs">
          {project.techs.map((tech, idx) => (
            <span key={idx} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="featured-links">
          <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
            Voir en ligne
          </a>
          <a href={project.githubUrl || "https://github.com/eliletishbit"} target="_blank" rel="noopener noreferrer" className="btn-outline">
            Code source
          </a>
        </div>
      </div>
    </div>
  );
};

// Filtres de catégorie
const ProjectFilters = ({ activeFilter, onFilterChange, categories }) => {
  return (
    <div className="project-filters">
      <button 
        className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
        onClick={() => onFilterChange('all')}
      >
        Tous
      </button>
      {categories.map(category => (
        <button 
          key={category}
          className={`filter-btn ${activeFilter === category ? 'active' : ''}`}
          onClick={() => onFilterChange(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

function Portfolio() {
  const [filter, setFilter] = useState('all');
  const [visibleProjects, setVisibleProjects] = useState(6);
  const [isLoading, setIsLoading] = useState(false);
  const [featuredProject, setFeaturedProject] = useState(null);

  // Données des projets
  const projects = [
    {
      id: 1,
      title: "Eclat d'Or",
      category: "WordPress",
      description: "Site vitrine luxueux pour une boutique d'accessoires haut de gamme",
      fullDescription: "Site vitrine luxueux pour une boutique d'accessoires haut de gamme. Design élégant, animations fluides et expérience utilisateur premium.",
      image: "./images/portfolioimg1.png",
      techs: ["WordPress", "Elementor", "SCSS", "js"],
      liveUrl: "https://eclatsdor.free.nf/?i=1",
      githubUrl: "https://github.com/eliletishbit"
    },
    {
      id: 2,
      title: "Payconnect",
      category: "React",
      description: "Interface de gestion d'echangeur de devise",
      fullDescription: "Interface de simulation Ui echangeur de devise . design proffesionnel ",
      image: "./images/portfolioimg3.png",
      techs: ["React 18", "Chart.js", "Context API", "Axios"],
      liveUrl: "https://payconnect-tau.vercel.app/",
      githubUrl: "https://github.com/eliletishbit"
    },
    {
      id: 3,
      title: "GKACOM",
      category: "WordPress",
      description: "Site web pour agence digitale ",
      fullDescription: "Site web pour agence digitale 360° . L'agence Gkacom est specialisée dans la communication digitale des entreprises sur tout les angles afin d'ameliorer leur image de marque ",
      image: "./images/portfolioimg2.png",
      techs: ["WordPress", "ACF", "PHP", "Bootstrap"],
      liveUrl: "https://gkacom.com/",
      githubUrl: "https://github.com/eliletishbit"
    },
    {
      id: 4,
      title: "Crypto Dashboard",
      category: "React",
      description: "Interface de suivi et de gestion d'actifs numériques en temps réel.",
      fullDescription: "Dashboard pour la visusalisation de la fluctuation des actifs bitcoin, etheureum et solana",
      image: "./images/cryptodash.png",
      techs: ["React", "Redux", "Tailwind", "Node.js"],
      liveUrl: "https://crypto-dashboard-two-sandy.vercel.app/",
      githubUrl: "https://github.com/eliletishbit"
    },
    {
      id: 5,
      title: "Movie tracker",
      category: "React",
      description: "Interface de suivi des dernières nouveautés du cinéma",
      fullDescription: "Plateforme interactive permettant aux utilisateurs de parcourir une vaste base de données de films, d'accéder à des détails précis (synopsis, notes, casting) et de maintenir une liste de favoris personnelle. L'application met en œuvre une recherche intuitive par mots-clés et une gestion d'état optimisée pour une navigation fluide entre les différentes catégories.",
      image: "./images/movietracker.png",
      techs: ["React", "Redux", "Tailwind", "Node.js"],
      liveUrl: "https://movie-tracker-pearl.vercel.app/",
      githubUrl: "https://github.com/eliletishbit"
    },
    {
      id: 6,
      title: "skysoftmeteo",
      category: "React",
      description: "Application pour  consulter la meteo",
      fullDescription: "Service web dynamique permettant aux utilisateurs de consulter les conditions météorologiques instantanées et des prévisions détaillées pour n'importe quelle localisation. L'application se distingue par son interface immersive, ses mises à jour de données fluides et une gestion réactive de l'affichage en fonction des informations reçues de l'API météo.",
      image: "./images/skysoftmeteo.png",
      techs: ["React", "Redux", "Tailwind", "Node.js"],
      liveUrl: "https://skyflowmeteo.netlify.app/",
      githubUrl: "https://github.com/eliletishbit"
    },
       {
      id: 7,
      title: "Serurier cotonou lead",
      category: "Javascript",
      description: "Landing page lead generation pour serurier cotonou",
      fullDescription: "Landing page lead generation pour serurier cotonou. optimisé pour convertir les visiteurs en clients? automatisation ia worflows: gmail , google sheet; whatsapp",
      image: "./images/leadgen.png",
      techs: ["Javascript", "Tailwind"],
      liveUrl: "https://voluble-eclair-f6b5cf.netlify.app/",
      githubUrl: "https://github.com/eliletishbit"
    },
      {
      id: 8,
      title: "Morijahcouture",
      category: "Laravel",
      description: "morijah couture est une plateforme specialisée dans la couture sur mesure de costume",
      fullDescription: "morijah couture est une plateforme ecommerce avancée copie du grand site Hockerty specialisée dans la couture sur mesure de costume. Vous pouvez vous inscrire en un clic choisisir et personnaliser votre costume sur mesure, renseigner les options de mesures et passer a la commande ",
      image: "./images/morijah.png",
      techs: ["Laravel", "Php", "Javascript", "react", "livewire", ],
      liveUrl: "https://morijahcouture-production.up.railway.app/",
      githubUrl: "https://github.com/eliletishbit"
    }
  ];

  // Sélectionner un projet vedette aléatoire
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * projects.length);
    setFeaturedProject(projects[randomIndex]);
  }, []);

  // Filtrer les projets
  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);
  
  const displayedProjects = filteredProjects.slice(0, visibleProjects);
  const hasMore = visibleProjects < filteredProjects.length;

  // Catégories uniques
  const categories = [...new Set(projects.map(p => p.category))];

  const loadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      setVisibleProjects(prev => prev + 3);
      setIsLoading(false);
    }, 500);
  };

  // Animation au scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.project-card').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [filteredProjects]);

  return (
    <div className="portfolio-page">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div className="hero-bg-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="hero-particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`
            }}></div>
          ))}
        </div>
        <div className="hero-content">
          <span className="hero-badge">Mes réalisations</span>
          <h1 className="hero-title">
            Créations <span className="title-gradient">digitales</span>
          </h1>
          <p className="hero-subtitle">
            Découvrez une sélection de projets web alliant <strong>design moderne</strong>, 
            <strong> performances optimales</strong> et <strong>expériences utilisateur uniques</strong>
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="stat-number">15+</span>
              <span className="stat-label">Projets livrés</span>
            </div>
            <div className="hero-stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Satisfaction</span>
            </div>
            <div className="hero-stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>
        </div>
        <div className="hero-scroll">
          <span>Découvrir</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      </section>

      {/* Featured Project */}
      {featuredProject && (
        <section className="featured-section">
          <div className="container">
            <div className="section-header">
              <span className="section-badge">Projet à la une</span>
              <h2 className="section-title">Réalisation <span className="title-gradient">phare</span></h2>
            </div>
            <FeaturedProject project={featuredProject} />
          </div>
        </section>
      )}

      {/* Projects Grid */}
      <section className="projects-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Mon portfolio</span>
            <h2 className="section-title">Projets <span className="title-gradient">récents</span></h2>
            <p className="section-subtitle">
              Une sélection de projets web réalisés avec passion et expertise
            </p>
          </div>

          <ProjectFilters 
            activeFilter={filter} 
            onFilterChange={setFilter} 
            categories={categories}
          />

          <div className="projects-grid">
            {displayedProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </div>

          {hasMore && (
            <div className="load-more-container">
              <button 
                className={`load-more-btn ${isLoading ? 'loading' : ''}`}
                onClick={loadMore}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <div className="loader"></div>
                    Chargement...
                  </>
                ) : (
                  <>
                    Voir plus de projets
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </>
                )}
              </button>
            </div>
          )}

          {filteredProjects.length === 0 && (
            <div className="no-results">
              <span>🔍</span>
              <h3>Aucun projet trouvé</h3>
              <p>Essayez une autre catégorie</p>
            </div>
          )}
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="container">
          <div className="cta-card">
            <h3>Vous avez un projet en tête ?</h3>
            <p>Ensemble, donnons vie à vos idées avec une solution web sur mesure</p>
            <a href="/contact" className="cta-btn">
              Discutons de votre projet
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portfolio;
